import {
  fetchProductImages,
  fetchProductSizes,
  fetchProductVariants,
  deleteProductVariant,
  bulkDeleteProductVariants,
  createProductVariant,
  bulkCreateProductVariants,
  updateProductVariant,
  bulkUpdateProductVariants
} from '../../services/products.service'
import { ActionTree } from 'vuex'
import { ProductState } from './product.types'
import { activeVariantFiler, ApiFilters, ProductVariant } from '../../types'
import { MutationTypes } from './product.mutations'
import { CreateVariantDTO } from '../../generated'

export const actions: ActionTree<ProductState, unknown> = {
  async fetchProductImages({ commit }, id: string) {
    try {
      const res = await fetchProductImages(id)
      commit('SET_PRODUCT_IMAGES', res)
    } catch (err) {
      commit('SET_PRODUCT_IMAGES_LOADING_ERROR', err)
    }
  },
  async fetchProductSizes({ commit }, { productId, sizeSpecId }: { productId: string; sizeSpecId: string }) {
    try {
      const res = await fetchProductSizes(productId, sizeSpecId)
      commit('SET_PRODUCT_SIZES', res)
    } catch (err) {
      commit('SET_PRODUCT_SIZES_LOADING_ERROR', err)
    }
  },
  async fetchProductVariants({ commit }, productId: string) {
    try {
      commit('SET_PRODUCT_VARIANTS_LOADING_ERROR', null)
      const res = await fetchProductVariants(productId)
      commit('SET_PRODUCT_VARIANTS', res)
    } catch (err) {
      commit('SET_PRODUCT_VARIANTS_LOADING_ERROR', err)
    }
  },
  async updateProductVariant(
    { commit },
    { productId, variantId, updates }: { productId: string; variantId: string; updates: Partial<ProductVariant> }
  ) {
    try {
      const res = await updateProductVariant(productId, variantId, updates)
      commit('SET_PRODUCT_VARIANTS', res)
    } catch (err) {
      commit('UPDATING_VARIANT_ERROR', err)
    }
  },
  async bulkUpdateProductVariants(
    { commit },
    { productId, variants, reorder }: { productId: string; variants: Array<Partial<ProductVariant>>; reorder?: boolean }
  ) {
    const updatedVariants = await bulkUpdateProductVariants(productId, variants, reorder)
    commit('SET_PRODUCT_VARIANTS', updatedVariants)
  },
  async deleteProductVariant({ commit }, { productId, variantId }: { productId: string; variantId: string }) {
    try {
      await deleteProductVariant(productId, variantId)
      commit('DELETE_PRODUCT_VARIANT', variantId)
    } catch (err) {
      commit('SET_DELETE_VARIANT_ERROR', err)
    }
  },
  async bulkDeleteProductVariants(
    { commit },
    { productId, variantIds }: { productId: string; variantIds: Array<string> }
  ) {
    try {
      const remainingVariants = await bulkDeleteProductVariants(productId, variantIds)
      commit('SET_PRODUCT_VARIANTS', remainingVariants)
    } catch (err) {
      commit('SET_DELETE_VARIANT_ERROR', err)
    }
  },
  async createProductVariant(
    { commit },
    {
      productId,
      variantData
    }: {
      productId: string
      variantData: CreateVariantDTO
    }
  ) {
    try {
      const res = await createProductVariant(productId, variantData)

      commit('SET_PRODUCT_VARIANTS', res)
    } catch (err) {
      commit('SET_CREATE_VARIANT_ERROR', err)
    }
  },
  async bulkCreateProductVariants(
    { commit },
    {
      productId,
      variants
    }: {
      productId: string
      variants: Array<CreateVariantDTO>
    }
  ) {
    try {
      const createdVariants = await bulkCreateProductVariants(productId, variants)

      commit('SET_PRODUCT_VARIANTS', createdVariants)
    } catch (err) {
      commit('SET_PRODUCT_VARIANTS_LOADING_ERROR', err)
    }
  },
  updateQuery({ commit }, update: Partial<ApiFilters>) {
    commit(MutationTypes.UPDATE_QUERY, update)
  },
  setVariantFilter({ commit }, filter: activeVariantFiler) {
    commit(MutationTypes.SET_VARIANTS_FILTER, filter)
  }
}
